import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import * as types from "./types";
import * as api from "./api";

const tokenReducer = (state = null, action) => {
  switch (action.type) {
    case types.MANUAL_SIGN_IN:
      return action.payload.token;
    case api.signIn.types.success:
      return action.payload.body.key;
    case api.linkedInSignIn.types.success:
      return action.payload.body.key;
    case types.SIGN_OUT:
      return null;
    default:
      return state;
  }
};

export default persistReducer(
  { storage, key: "token", whitelist: ["token"] },
  combineReducers({
    api: combineReducers({
      linkedInSignIn: api.linkedInSignIn.reducer,
      signIn: api.signIn.reducer,
      signUp: api.signUp.reducer,
      InsiderSignUp: api.insiderSignUp.reducer,
      resetPassword: api.resetPassword.reducer,
      setPassword: api.setPassword.reducer,
      fetchUserData: api.fetchUserData.reducer,
      getDiscountInfo: api.getDiscountInfo.reducer,
      checkUserDiscount: api.checkUserDiscount.reducer
    }),
    token: tokenReducer
  })
);



// WEBPACK FOOTER //
// ./src/modules/user/auth/reducer.js